import localforage from 'localforage';

/**
 * Best-effort cache clear for the app:
 * - Clears all IndexedDB entries used by localforage (library, onboarding, persist blobs).
 * - Removes prefixed localStorage keys we use as mirrors or fast-paths.
 */
export const clearAllCaches = async () => {
  try {
    await localforage.clear();
  } catch {
    // ignore
  }

  if (typeof window === 'undefined' || !window.localStorage) return;

  try {
    const keysToRemove: string[] = [];
    for (let i = 0; i < window.localStorage.length; i += 1) {
      const key = window.localStorage.key(i);
      if (!key) continue;
      if (
        key.startsWith('cmf.') ||
        key.startsWith('persist:') ||
        key.startsWith('reduxPersist:') ||
        key.startsWith('favorite-action')
      ) {
        keysToRemove.push(key);
      }
    }
    for (const key of keysToRemove) {
      try {
        window.localStorage.removeItem(key);
      } catch {
        // ignore individual failures
      }
    }
  } catch {
    // ignore
  }
};
